import { LinePlannerWPOFiltersAction } from "../types/actions";
import { LinePlannerFilters } from "../types/linePlanner";
import { DateTime } from "luxon";
import { statusOptions, hangarLineOptions } from '../properties/lineProperties';

const currentDate = new Date();
const linePlannerDateFrom = DateTime.fromJSDate(currentDate).minus({ days: 3 }).toISO();
const linePlannerDateTo = DateTime.fromJSDate(currentDate).plus({ days: 14 }).toISO();

const filtersInitial = {
	linePlannerfilters:{
		dateFrom: linePlannerDateFrom,
		dateTo: linePlannerDateTo,
		tail: "",
		filterByHangers: [	
			hangarLineOptions.kefLine,
			hangarLineOptions.rkvLine,
			hangarLineOptions.kefHangarBay1,
			hangarLineOptions.kefHangarBay2,
			hangarLineOptions.kefHangarBay3
		],
		filterByStatus: [statusOptions.commit],
		dueDateHourCycles: false,
		dueDateExceedsFifteen: false,
		filterByWorkType: [],
		filterByAircraftTypes: [],
	} as LinePlannerFilters,
}

export const linePlannerReducer = (state = { ...filtersInitial }, action: LinePlannerWPOFiltersAction) => {
	switch (action.type) {
		case 'LINE_PLANNER_WORK_PACKAGE_OVERVIEW_FILTERS': 
			return { ...state, linePlannerfilters: action.linePlannerfilters };
		default:
			return state;
	}
}
